<template>
  <vs-row vs-type="flex" vs-w="12" id="cartEntryPage" class="pt-6" style="height:100%!important;">
    <recipe-reviewer ref="recipeReviewer"/>
    <product-description ref="productDescription"/>
    <vs-popup :active.sync="isVariantSelectionOpen" title="Alternatif Ürün Seçimi" id="variant-first-selection">
      <vs-row vs-type="flex" vs-w="12" class="bg-primary2">
        <vs-col vs-type="flex" vs-w="12" vs-justify="space-between" class="mx-5 py-4">
          <vs-button radius icon-pack="feather" icon="icon-x" color="tranparent" class="bg-secondary text-primary"
                     @click="closeVariantSelection"></vs-button>
        </vs-col>
      </vs-row>
      <vs-row v-if="selectedRawMaterial!=null" vs-type="flex" vs-w="12" vs-justify="center" class="p-5">
        <vs-col vs-type="flex" class="w-auto mx-5 my-3" v-for="(variant) in selectedRawMaterial.variants"
                :key="variant.id">
          <vs-button class="half-friendly-border bold sale-box-shadow text-dark"
                     :class="{'bg-primary text-white' : variant.selected}" @click="variantSelection(variant)"
                     size="large"
                     color="transparent">{{ variant.name }}
          </vs-button>
        </vs-col>
      </vs-row>

    </vs-popup>

    <vs-row v-show="!isExtraSelectionOpen" vs-w="12" vs-justify="center">
      <vs-col vs-w="3">
        <vs-row vs-type="flex" vs-w="12">
          <vs-button v-if="selectedRecipe.productExtras!=null && selectedRecipe.productExtras.length>0" size="small"
                     class="w-full mt-6 bold extra-button text-white half-friendly-border bg-primary2 sale-box-shadow"
                     color="transparent" @click="openExtraSelection">
            Ekstralar
          </vs-button>
          <div class="w-full extra-list text-primary bold">
            <vs-row v-for="extra in realSelectedExtras" :key="extra.id" vs-w="12" class="py-2 px-5"
                    style="border-bottom:0.1rem solid black" vs-justify="center">
              <vs-col vs-type="flex" class="w-auto">
                + {{ extra.quantity + " " }} {{ " " + extra.name + " " }}
                {{ $toCurrency(extra.quantity * extra.price) }}
              </vs-col>
            </vs-row>
          </div>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="4">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vx-tooltip :text="description" position="right">
              <img
              :src="selectedProduct && selectedProduct.imageUrl ? $baseUrl + '/' + selectedProduct.imageUrl : toUpdateEntry && toUpdateEntry.rawProduct.imageUrl ? $baseUrl + '/' + toUpdateEntry.rawProduct.imageUrl : productPlaceHolder"
              class="responsive w-64 cartEntryImg" @click="openRecipeReviewer">
            </vx-tooltip>

          </vs-row>
          <vs-row vs-w="12" vs-justify="center" class="mt-5">
            <vs-button @click="quantity++"
                       class="sale-text-shadow bg-primary2 sale-box-shadow text-light quantity-label half-friendly-border"
                       color="transparent" style="height:3.5rem!important;">Adet
            </vs-button>
          </vs-row>
          <vs-row vs-w="12" vs-justify="center" vs-align="center">
            <vs-button class="quantity-button bg-white text-primary" size="medium" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-minus" @click="quantity > 1 ? quantity-- : null">
            </vs-button>
            <p class="selected-quantity">{{ quantity }}</p>
            <vs-button class="quantity-button bg-white text-primary" size="medium" radius color="transparent"
                       type="gradient" icon-pack="feather" icon="icon-plus" @click="quantity++"></vs-button>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-w="3" class="mt-6 pr-6">
        <vs-chip color="secondary" class="variant-title" v-show="name.length > 0" v-for="name in productName"
                 :key="name">{{ name }}
        </vs-chip>
        <vs-chip color="secondary" class="variant-title">
          {{ $toCurrency(selectedRecipe.price) }}
        </vs-chip>
        <vx-tooltip :text="description" position="right" >
        <vs-button @click="openDescription"
                       class="sale-text-shadow bg-primary2 sale-box-shadow text-light quantity-label half-friendly-border"
                       color="transparent" style="height:3.5rem!important;">Bilgi
            </vs-button>
          </vx-tooltip>
      </vs-col>
    </vs-row>
    <vs-row v-if="isRawMaterialsReload && !isExtraSelectionOpen" vs-type="flex" vs-w="12" vs-justify="center" id="cartEntryRecipeSteps"
            class="px-3">
      <div class="my-2 px-1 pointer" style="width: 30%;height: 90px;"
           v-for="(step) in selectedRecipe.recipeSteps.filter(x=> (x.rawMaterial.variants != null && x.rawMaterial.variants.length > 0) || x.isRemovable === true)"
           :key="step.id"
      >
        <div class="w-full h-full">
          <div class="recipeStepHeader justify-center w-full variant-label sale-text-shadow px-2 py-1"
               :class="{'bg-primary2' : step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0, 'bg-secondary' : step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0 }"
               style="position: relative; min-height: 29px;">
            <p
              v-if="step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0"
              class="text-white text-primary">
              {{ step.rawMaterial.name }}</p>
            <vs-button @click="removeRecipeStep(step)"
                       v-if="step.isRemovable === true"
                       icon-pack="feather" style="position: absolute; right: 0; top: -3px;"
                       :class="{'text-dark' : step.rawMaterial.variants == null || step.rawMaterial.variants.length === 0, 'text-white' : step.rawMaterial.variants != null && step.rawMaterial.variants.length !== 0}"
                       icon="icon-x" color="transparent" type="gradient"/>
          </div>
          <div class="recipeStepDetail justify-center bg-secondary d-flex mx-auto overflow-auto"
               :class="{'sale-box-shadow' : step.isRemoved === false}"
               style="height: inherit; flex-direction: column; width: 90%" @click="updateVariant(step.rawMaterial)">
            <p class="text-smaller text-center bold px-2"
            :class="{'line-through' : step.isRemoved === true, 'text-dark' : step.isRemoved === false}">
              {{
                step.rawMaterial.variants != null && step.rawMaterial.variants.length > 0 ? getSelectedVariant(step.rawMaterial.variants).name : step.rawMaterial.name
              }}</p>
          </div>
        </div>
      </div>
    </vs-row>

    <vs-row v-if="isExtraSelectionOpen" vs-type="flex" vs-w="12">
      <extra-selection :extras="selectedExtras.length>0?selectedExtras:selectedRecipe.productExtras"
                       @saveExtras="saveExtraSelection" @cancelExtras="cancelExtraSelection"></extra-selection>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-5" vs-justify="center" v-if="!isExtraSelectionOpen">
      <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end">
        <vs-button class="action-button sale-box-shadow mr-5" color="danger" type="gradient"
                   style="height:4rem!important;" @click="GoToProductSelectPage" icon-pack="feather"
                   icon="icon-arrow-left">
          VAZGEÇ
        </vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-w="5" vs-offset="1">
        <vs-button class="action-button sale-box-shadow ml-5 bg-success2 text-light" style="height:4rem!important;"
                   :disabled="addToCartInFlight"
                   @click.prevent="AddToCart" color="transparent" icon-pack="feather" icon="icon-arrow-right" icon-after>
          ONAYLA
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import RecipeReviewer from "@/views/pages/Recipe/RecipeReviewer";
import ExtraSelection from "./ExtrasSelection";
import ProductDescription from "./ProductDescription";
import cartEntryMixin from "./cartEntryMixin";

export default {
  name: "CartEntryDesktop",
  components: {
    ExtraSelection,
    RecipeReviewer,
    ProductDescription,
  },
  mixins: [cartEntryMixin],
};
</script>

<style lang="scss" src="./CartEntryDesktop.scss"></style>
